import React, { useState } from "react";

const permissionContext = React.createContext();

export default permissionContext;
